export default __webpack_public_path__ + "static/media/lock.e9bf4848.svg";